<template>
  <div class="footer" style="padding: 20px">
    <el-row>
      <el-col :span="24">
        <div
          style="font-size: 16px; color: #4aa3ec; text-align: center;margin-top:20px"
          class="center"
        >
          <!-- <el-avatar shape="square" size="large" src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar> -->
          <!-- Copyright © 2002-2015 xxxxx.xxxxx.xxxxx 版权所有 赣ICP备10001373号-4 虔卫网审[2015年号]第004号 -->
          版本号：V2.01.25.01.11
        </div>
      </el-col>
    </el-row>
  </div>
</template> 

<script>
export default {
  /*组件名称，暴露后用这个名称来import和使用，一般name和vue文件名和将来引用import名称和 注册components:{}中写的组件名称，都是同一个名称*/
  name: "MainFooter",
  /*组件数据，用于插值*/
  data() {
    return {
      something: "",
    };
  },

  /*组件的方法*/
  methods: {
    dosomething() {},
  },

  /*组件属性，接收使用了组件的vue传过来的值，通过this.XXX来使用*/
  props: [],
};
</script>

<style scoped>

.footer{
    height: 60px;
    /*background: -webkit-gradient(linear,left top,left bottom,from(#67C23A),to(#77bd57));*/
    /* background: -webkit-gradient(linear,left top,left bottom,from(#67C23A),to(#77bd57)); */
    background: #d0e6f8;
    background-size:100% 100%; 
    margin-top: 0px;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>